/*
  Montana Fruit Trees: one search matcher, shared by every box on the site that
  filters a list of names.

  Plain typing is unchanged. Words separated by spaces all have to match, the
  way they always did, so "cox orange pippin" still finds Cox Orange Pippin and
  nobody has to learn anything.

  On top of that:
    "pink pearl"    a phrase in quotes, matched as those words together
    -crab           a minus sign drops anything matching it
    plum OR cherry  either side will do

  Punctuation is ignored on both sides, so hewes finds Hewe's, and a word also
  matches when the spacing differs, so honey crisp finds Honeycrisp.

  Anything it cannot make sense of falls back to treating the whole line as
  ordinary words, so a stray quote never leaves someone with an empty list.
*/
(function () {
  if (window.MFTSearch) return;

  function spaced(s) {
    return String(s == null ? '' : s).toLowerCase().replace(/[^a-z0-9]+/g, ' ').replace(/^ | $/g, '');
  }
  function tight(s) {
    return String(s == null ? '' : s).toLowerCase().replace(/[^a-z0-9]+/g, '');
  }

  // Pull the line apart into quoted phrases, minus terms, the word OR, and
  // plain words. Anything the quote is missing its partner for is treated as
  // plain text rather than thrown away.
  function tokenize(q) {
    var out = [];
    var re = /"([^"]*)"|(\S+)/g;
    var m;
    while ((m = re.exec(q)) !== null) {
      if (m[1] !== undefined) {
        out.push({ kind: 'phrase', raw: m[1], neg: false });
      } else {
        var w = m[2];
        var neg = false;
        if (w.length > 1 && (w.charAt(0) === '-' || w.charAt(0) === '!')) {
          neg = true;
          w = w.slice(1);
        }
        if (!neg && (w === '|' || w.toUpperCase() === 'OR')) {
          out.push({ kind: 'or' });
          continue;
        }
        // A quote that never closed: keep the text, drop the quote.
        w = w.replace(/"/g, '');
        if (w) out.push({ kind: 'word', raw: w, neg: neg });
      }
    }
    return out;
  }

  function term(tok) {
    return {
      phrase: tok.kind === 'phrase',
      sp: spaced(tok.raw),
      tg: tight(tok.raw)
    };
  }

  function parse(q) {
    var toks = tokenize(q == null ? '' : q);
    var groups = [];   // every group has to match; inside a group any one will do
    var nots = [];
    var orNext = false;

    for (var i = 0; i < toks.length; i++) {
      var t = toks[i];
      if (t.kind === 'or') {
        // A trailing or leading OR is just noise, ignore it.
        if (groups.length) orNext = true;
        continue;
      }
      var tm = term(t);
      if (!tm.tg) continue;
      if (t.neg) {
        nots.push(tm);
        orNext = false;
        continue;
      }
      if (orNext && groups.length) {
        groups[groups.length - 1].push(tm);
      } else {
        groups.push([tm]);
      }
      orNext = false;
    }
    return { groups: groups, nots: nots, empty: !groups.length && !nots.length };
  }

  function hit(tm, sp, tg) {
    if (tm.phrase) return tm.sp ? sp.indexOf(tm.sp) > -1 : false;
    return sp.indexOf(tm.sp) > -1 || tg.indexOf(tm.tg) > -1;
  }

  function test(parsed, text) {
    if (!parsed || parsed.empty) return false;
    var sp = spaced(text), tg = tight(text), i, j, any;
    for (i = 0; i < parsed.nots.length; i++) {
      if (hit(parsed.nots[i], sp, tg)) return false;
    }
    for (i = 0; i < parsed.groups.length; i++) {
      any = false;
      for (j = 0; j < parsed.groups[i].length; j++) {
        if (hit(parsed.groups[i][j], sp, tg)) { any = true; break; }
      }
      if (!any) return false;
    }
    return true;
  }

  // A line that is nothing but exclusions ("-crab") would otherwise match the
  // whole catalogue, which is not what anyone means by it.
  function onlyNots(parsed) {
    return !!parsed && !parsed.groups.length && parsed.nots.length > 0;
  }

  function match(q, text) {
    return test(parse(q), text);
  }

  window.MFTSearch = {
    parse: parse,
    test: test,
    match: match,
    onlyNots: onlyNots,
    spaced: spaced,
    tight: tight
  };
})();
